import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  inputPeriod: {
    border: '1px solid white',
    borderRadius: '23px',
    width: '200px',
    textAlign: 'center',
  },
}))

export default styles
